export const { location, document, addEventListener, removeEventListener, scrollTo } = window;
